const operatorsTypeData = [
  { label: '中国移动', value: 'cmcc' },
  { label: '中国联通', value: 'unicom' },
  { label: '中国电信', value: 'telecom' },
  { label: '中国广电', value: 'cbn' },
];
const goodsTypeData = [
  { label: '号卡', value: 'order' },
  { label: '流量卡', value: 'IotCard' },
  { label: '设备', value: 'equipment' },
];
const callDurationData = [
  { label: '含通话', value: 'Y' },
  { label: '不含通话', value: 'N' },
];
const priceData = [
  { label: '5元以下', value: '0-5', minVal: 0, maxVal: 5, scale: '20%' },
  { label: '5-20元', value: '5-20', minVal: 5, maxVal: 20, scale: '30%' },
  { label: '21-40元', value: '21-40', minVal: 21, maxVal: 40, scale: '49%' },
  { label: '40元以上', value: '40', minVal: 40, scale: '1%' },
];
const cardOrderStatusData = [
  { label: '审核中', value: 'under_review' },
  { label: '审核中', value: 'in_process' },
  { label: '审核中', value: 'wait_edit' },
  { label: '审核中', value: 'wait_photo' },
  { label: '审核中', value: 'pre_check' },
  { label: '审核中', value: 'wait_again' },
  { label: '待发货', value: 'no_shipped' },
  { label: '已发货', value: 'shipped' },
  { label: '已失败', value: 'error' },
  { label: '已失败', value: 'intercept' },
  { label: '已失败', value: 'abnormal' },
  { label: '已放弃', value: 'give_up' },
  { label: '已签收', value: 'activate' },
  { label: '已签收', value: 'first_flush' },
];
const cancelReasonData = [
  { label: '无信号', value: '1' },
  { label: '有信号不能用网', value: '2' },
  { label: '网络卡顿', value: '3' },
  { label: '已有其他卡', value: '4' },
  { label: '套餐贵', value: '5' },
  { label: '无法续约', value: '6' },
  { label: '短期内用不到', value: '7' },
  { label: '套餐不符', value: '8' },
  { label: '无语音短信功能', value: '9' },
  { label: '无法注册APP', value: '10' },
  { label: '卡丢了', value: '11' },
  { label: '没有5G', value: '12' },
  { label: '其他', value: '13' },
];

// rgba 颜色格式
const lightColorMap: Record<string, string> = {
  success: '82, 196, 26',
  red: '255, 77, 79',
  blue: '24, 144, 255',
  orange: '250, 140, 22',
  purple: '114, 46, 209',
  cyan: '143, 227, 235',
  magenta: '235, 47, 150',
  pink: '255, 92, 179',
  yellow: '250, 219, 20',
  volcano: '250, 84, 28',
  gold: '250, 173, 20',
  lime: '160, 217, 17',
  geekblue: '24, 144, 255',
  'blue-inverse': '24, 144, 255',
  'purple-inverse': '114, 46, 209',
  'green-inverse': '82, 196, 26',
  'magenta-inverse': '235, 47, 150',
  'pink-inverse': '255, 92, 179',
  'red-inverse': '255, 77, 79',
  'orange-inverse': '250, 140, 22',
  'yellow-inverse': '250, 219, 20',
  'volcano-inverse': '250, 84, 28',
  'gold-inverse': '250, 173, 20',
  'lime-inverse': '160, 217, 17',
  'geekblue-inverse': '24, 144, 255',
  'cyan-inverse': '143, 227, 235',
};
export {
  operatorsTypeData,
  goodsTypeData,
  priceData,
  callDurationData,
  cardOrderStatusData,
  cancelReasonData,
  lightColorMap,
};
